/**
 * HubSpot deal stage IDs mapped to semantic stage names
 *
 * These stage IDs correspond to the deal pipeline stages configured in HubSpot.
 * Each stage represents a specific point in the customer journey for both
 * buy and sell transactions.
 *
 * Note: Stage IDs are HubSpot-specific and must match the configured pipeline
 */
export const HUBSPOT_STAGES: Record<string, string> = {
  BUY_PROCESS_ORDER: "259476547", // Qualified buy lead // maybe switched
  SELL_PROCESS_ORDER: "264262987", // Qualified sell lead

  BUY_ATTEMPTING_TO_CONTACT: "259476548",
  SELL_ATTEMPTING_TO_CONTACT: "264262988",

  BUY_NEGOTIATION: "259476549",
  SELL_NEGOTIATION: "264262989",

  BUY_PENDING: "259476550", // Customer completed buy transaction
  SELL_PENDING: "264262990", // Customer completed sell transaction

  BUY_WAITING_FOR_BUYER: "259476551",
  SELL_WAITING_FOR_BUYER: "264262991",

  BUY_CLOSED_WON: "259476552",
  SELL_CLOSED_WON: "264262992",

  BUY_BUSINESS_LOST: "259476553",
  SELL_BUSINESS_LOST: "264262993",
};

/**
 * Business transaction type classifications
 *
 * These constants define the two primary business models supported by
 * The Miles Market platform. Used for deal categorization, pipeline
 * routing, and business intelligence reporting.
 */
export const BUSINESS_TYPES: Record<string, string> = {
  BUY: "Sales", // Customer purchasing miles/points from The Miles Market
  SELL: "Purchase", // Customer selling miles/points to The Miles Market
};

/**
 * HubSpot field values for buy/sell transaction types
 *
 * These values are used to populate HubSpot custom fields that track
 * the transaction type. Must match the configured dropdown values
 * in HubSpot custom properties.
 */
export const BUY_SELL_HUBSPOT_VALUES: Record<string, string> = {
  BUY: "Buy", // HubSpot field value for buy transactions
  SELL: "Sell", // HubSpot field value for sell transactions
};

/**
 * Field value mappings for HubSpot custom properties
 *
 * This object contains mappings between internal enum values and the
 * corresponding display values used in HubSpot. These mappings ensure
 * consistent data representation across the platform and CRM.
 *
 * Each field mapping should match the configured dropdown options
 * in HubSpot custom properties to prevent data validation errors.
 */
export const FIELD_VALUES: Record<string, string> = {
  // Payment method options with detailed descriptions
  PAYPAL: "Recommended: PayPal - Get paid today - PayPal takes a fee of 2.9%",
  ECHECK: "Echeck - Get paid within 2-6 weeks, no fees",
  WIRE: "Wire Get paid within 2-6 weeks, $25 fee",

  // Miles expiration timeframes for customer miles/points
  THREE_MONTHS: "Next 3-6 Months", // Miles expiring in 3 months
  SIX_MONTHS: "Next 3-6 Months", // Miles expiring in 6 months
  ONE_YEAR: "Over 6 Months", // Miles expiring in 1 year
  NEVER: "Never", // Miles that never expire
};
